import script from "./QIncidentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./QIncidentItem.vue?vue&type=script&setup=true&lang=js"

import "./QIncidentItem.vue?vue&type=style&index=0&id=d50e3aa8&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d50e3aa8"]])

export default __exports__